/**
 * @module addStateAbbrevs
 */
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import { fromLonLat } from 'ol/proj.js';
import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { Fill, Stroke, Text, Style } from 'ol/style';

/**
 * Add state abbreviation labels to an OpenLayers map.
 * @param {object} map - The OpenLayers map object.
 * @param {boolean} visible - Whether the layer should be visible by default.
 * @param {string} fontSize - The font size for the state abbreviations.
 * @returns {object} vectorLayer
 */
function getStateAbbrLayer(map, visible, fontSize) {
  // Latitude and Longitude points (states only, removing country points)
  const slat = [32.4, 65.0, 34.7, 35.0, 36.5, 39.0, 41.6, 38.8, 28.5, 32.5, 
    20.0,43.5, 40.2, 40.0, 42.0, 38.5, 37.4, 31.2, 45.5, 39.3, 42.3, 43.0,
    46.0, 32.5, 38.5, 47.0, 41.5, 39.8, 43.2, 39.7, 34.7, 43.0, 35.5,
    47.5, 40.2, 35.6, 44.0, 40.8, 41.7, 34.0, 44.5, 35.8, 31.0, 39.5,
    44.2, 37.6, 47.5, 38.5, 44.5, 43.0];
  
  const slon = [-87.1, -152.0, -111.5, -92.5, -119.5, -105.8, -72.6, -75.3, 
    -82.0,-83.0, -157.0, -114.0, -89.2, -86.0, -93.2, -98.2, -84.5, -92.5,
    -69.0, -77.0, -72.0, -84.8, -94.5, -89.5, -92.5, -109.5, -99.5,
    -117.0, -71.6, -74.7, -106.0, -75.0, -79.5, -100.5, -82.5, -97.5,
    -120.2, -77.6, -71.5, -80.5, -100.5, -86.5, -99.0, -111.5, -72.6,
    -78.6, -120.5, -80.8, -89.5, -107.5];
  
  const names = ["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID",
    "IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT",
    "NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI",
    "SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];
  
  // Create a vector layer for the points
  const features = [];
  for (let i = 0; i < slat.length; i++) {
    const feature = new Feature({
    geometry: new Point(fromLonLat([slon[i], slat[i]])),
    name: names[i]
    });
    features.push(feature);
  }
  
  const vectorSource = new VectorSource({
    features: features
  });
  
  const vectorLayer = new VectorLayer({
    source: vectorSource,
    zIndex: 99,
    visible: visible,
    style: function(feature) {
      const zoom = map.getView().getZoom();
      return new Style({
        text: new Text({
        font: `bold ${fontSize} Calibri,sans-serif`,
        overflow: true,
        fill: new Fill({
          color: '#000'
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 3
        }),
        text: (zoom <= 6 && zoom>3) ? feature.get('name') : ''
        }),
      });
    }
  });

  return vectorLayer;
}

export { getStateAbbrLayer };